import { Component, Input } from '@angular/core';

import { fichasFilter } from '../../helpers/filter';
import { FichaListaFiltro } from './../model/ficha-lista-filtro';

@Component({
  selector: 'app-ficha-contrato-cancelado',
  templateUrl: './ficha-contrato-cancelado.component.html',
  styleUrls: ['./ficha-contrato-cancelado.component.css']
})
export class FichaContratoCanceladoComponent {
  @Input() propostas = [];
  @Input() filtro: FichaListaFiltro;

  filter() {
    return fichasFilter(this.filtro, this.propostas);
  }
}
